const getButtonVariant = (item) => {
  return item.parameters?.buttonVariant && ["solid", "ghost", "outline"].indexOf(item.parameters?.buttonVariant) > -1 ? item.parameters?.buttonVariant : "solid";
};
const getButtonColor = (item) => {
  return item.parameters?.buttonColor && ["primary", "secondary"].indexOf(item.parameters?.buttonColor) > -1 ? item.parameters?.buttonColor : "primary";
};
export {
  getButtonColor,
  getButtonVariant
};
//# sourceMappingURL=helpers.js.map
